"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJsonGeofence = void 0;
const class_validator_1 = require("class-validator");
const IsGeofenceType_1 = require("../validators/IsGeofenceType");
const IsGeoJsonGeofenceCoordinates_1 = require("../validators/IsGeoJsonGeofenceCoordinates");
class GeoJsonGeofence {
    /**
     * type = "Polygon"
     */
    type;
    /**
     * "coordinates": [[ longitude, latitude ][]]
     *  Example: [[[ 1, 2 ], [3, 4], [5, 6], [1, 2]]]
     */
    coordinates;
}
exports.GeoJsonGeofence = GeoJsonGeofence;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Validate)(IsGeofenceType_1.IsGeofenceType),
    __metadata("design:type", String)
], GeoJsonGeofence.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Validate)(IsGeoJsonGeofenceCoordinates_1.IsGeoJsonGeofenceCoordinates),
    __metadata("design:type", Array)
], GeoJsonGeofence.prototype, "coordinates", void 0);
//# sourceMappingURL=GeoJsonGeofence.js.map